<template>
    <div class="footer-content">
        <div class="content">
            <div class="item">
                <div class="title">ชื่อบริษัท</div>
                <div class="text">บริษัท วัฒธนาธร จำกัด WATTHANATHORN COMPANY LIMITED</div>
            </div>
            <div class="item">
                <div class="title">ที่อยู่ธุรกิจที่จดทะเบียน</div>
                <div class="text">135/156 ตรอกอาคาร 7 แขวงคลองเตย เขตคลองเตย กรุงเทพมหานคร 10110</div>
            </div>
            <div class="item">
                <div class="title">หมายเลขบริษัท</div>
                <div class="text">0105565034638</div>
            </div>
        </div>
        <div class="content">
            <div class="item">
                <div class="title">Pico Finance</div>
                <div class="text">221/2565</div>
            </div>
            <div class="item">
                <div class="title">ที่อยู่อีเมล</div>
                <div class="text">team@watthanathorn.com</div>
            </div>
            <div class="item">
                <div class="title">เบอร์โทร</div>
                <div class="text">+66 0855193237</div>
            </div>
        </div>
    </div>
</template>
<script setup></script>
<style lang="less" scoped>
.footer-content {
    width: 1440px;
    height: 284px;
    background: #2D3439;
    padding-top: 46px;
    padding-left: 268px;
    box-sizing: border-box;

    .content {
        display: flex;
        margin-bottom: 33px;

        .item {
            width: 282px;
            margin-right: 59px;

            .title {
                font-weight: bold;
                font-size: 17px;
                color: #FFFFFF;
                line-height: 12px;
                margin-bottom: 14px;
            }

            .text {
                font-weight: 500;
                font-size: 14px;
                color: #DCDCDC;
                line-height: 20px;
            }
        }

        .item:last-child {
            margin-right: 0;
        }
    }
}
</style>